module.exports = __webpack_public_path__ + "static/media/bpn.c08b748b.jpg";